import { ViewClassesTranslations } from './types';

export const enTranslations: ViewClassesTranslations = {
    title: "View Classes",
    columns: {
        className: "Name",
        classCode: "Class Code",
        status: "Status",
        patientsSeen: "Patients Seen",
        patientsDischarged: "Patients Discharged",
        dateCreated: "Date Created",
        review: "Review"
    },
    actions: {
        review: "Review"
    },
    errors: {
        loadingFailed: "Failed to load classes"
    }
};